import { call, put, takeLatest } from "redux-saga/effects";
import constants from "constants";
import actions from "actions";

const {
  API_HOSPITALS,
  LOAD_HOSPITALS_SAGA,
  LOAD_COUNTIES_SAGA,
  LOAD_BRANCHES_SAGA,
  LOAD_COUNTRIES_SAGA,
  API_COUNTIES,
  API_BRANCHES,
  API_COUNTRIES,
  LOAD_SPONSORS_SUGGESTIONS_SAGA,
  LOAD_PARTNERS_SUGGESTIONS_SAGA,
  LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA,
  API_SPONSORS,
  API_PARTNERS,
  API_ADMIN_USERS_SPONSORS,
} = constants;

const {
  addHospitalSuggestions,
  addCountySuggestions,
  addBranchSuggestions,
  addCountriesSuggestions,
  addRequestError,
  addSponsorSuggestions,
  addPartnerSuggestions,
  addSponsorUsersSuggestions,
} = actions;

const apiLoadHospitalsSaga = (q) => axios.get(`${API_HOSPITALS}?title=${q}`);

const apiLoadCountiesSaga = (q) => axios.get(`${API_COUNTIES}?title=${q}`);

const apiLoadBranchesSaga = (q) => axios.get(`${API_BRANCHES}?title=${q}`);

const apiLoadCountriesSaga = (q) => axios.get(`${API_COUNTRIES}?title=${q}`);

const apiLoadSponsorsSaga = (q) => axios.get(`${API_SPONSORS}?title=${q}`);

const apiLoadPartnersSaga = (q) => axios.get(`${API_PARTNERS}?title=${q}`);

const apiLoadSponsorUsersSaga = (q) =>
  axios.get(`${API_ADMIN_USERS_SPONSORS}?title=${q}`);

function* loadHospitals({ q }) {
  try {
    const response = yield call(apiLoadHospitalsSaga, q);
    const hospitals = response.data.hospitals;
    yield put(addHospitalSuggestions(q, hospitals));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadCountiesSaga() {
  try {
    const response = yield call(apiLoadCountiesSaga);
    const counties = response.data.counties;
    const suggestCounties = Object.keys(counties).map((county) => ({
      value: county,
      label: county,
    }));
    yield put(addCountySuggestions(suggestCounties));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadBranchesSaga() {
  try {
    const response = yield call(apiLoadBranchesSaga);
    const branches = response.data.branches;
    const suggestBranches = Object.keys(branches).map((branch) => ({
      value: branch,
      label: branch,
    }));
    yield put(addBranchSuggestions(suggestBranches));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadCountriesSaga() {
  try {
    const response = yield call(apiLoadCountriesSaga);
    const countries = response.data.countries;
    const suggestCountry = Object.keys(countries).map((country) => ({
      value: country,
      label: country,
    }));
    yield put(addCountriesSuggestions(suggestCountry));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadSponsorsSaga({ q = "" }) {
  try {
    const response = yield call(apiLoadSponsorsSaga, q);
    const sponsors = response.data.sponsors;

    const suggestSponsors = sponsors.map((sponsor) => ({
      value: sponsor.id,
      label: sponsor.title,
    }));

    yield put(addSponsorSuggestions(suggestSponsors));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadPartnersSaga({ q = "" }) {
  try {
    const response = yield call(apiLoadPartnersSaga, q);
    const partners = response.data.partnerships;

    const suggestSponsors = partners.map((partner) => ({
      value: partner.id,
      label: partner.title,
    }));

    yield put(addPartnerSuggestions(suggestSponsors));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadSponsorUsersSaga({ q = "" }) {
  try {
    const response = yield call(apiLoadSponsorUsersSaga, q);
    const sponsors = response.data.sponsors;

    const suggestSponsorUsers = sponsors.map((sponsor) => ({
      value: sponsor.id,
      label: sponsor.full_name,
    }));

    yield put(addSponsorUsersSuggestions(suggestSponsorUsers));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* __loadHospitalsSaga() {
  yield takeLatest(LOAD_HOSPITALS_SAGA, loadHospitals);
}
function* __loadCountiesSaga() {
  yield takeLatest(LOAD_COUNTIES_SAGA, loadCountiesSaga);
}

function* __loadBranchesSaga() {
  yield takeLatest(LOAD_BRANCHES_SAGA, loadBranchesSaga);
}

function* __loadCountriesSaga() {
  yield takeLatest(LOAD_COUNTRIES_SAGA, loadCountriesSaga);
}

function* __loadSponsorSuggestionsSaga() {
  yield takeLatest(LOAD_SPONSORS_SUGGESTIONS_SAGA, loadSponsorsSaga);
}

function* __loadPartnerSuggestionsSaga() {
  yield takeLatest(LOAD_PARTNERS_SUGGESTIONS_SAGA, loadPartnersSaga);
}

function* __loadSponsorUsersSuggestionSaga() {
  yield takeLatest(LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA, loadSponsorUsersSaga);
}

export {
  __loadHospitalsSaga,
  __loadCountiesSaga,
  __loadBranchesSaga,
  __loadCountriesSaga,
  __loadSponsorSuggestionsSaga,
  __loadPartnerSuggestionsSaga,
  __loadSponsorUsersSuggestionSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/suggestions.js